export { default } from '@/screens/ForgotPasswordScreen';
